// hooks/use-search.ts
import { useState, useMemo } from "react";

export function useSearch(sections, sites, currentSite) {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const searchableItems = useMemo(() => {
    const items = [];
    // Add sections
    sections.forEach((section) => {
      items.push({
        id: `section-${section.id}`,
        type: "section",
        name: section.name,
        sectionId: section.id,
        icon: section.icon,
        progress: section.progress,
        status: section.status,
        path: `/audit/${currentSite?.id}/${section.id}`,
      });
    });

    // Add sites
    sites.forEach((site) => {
      items.push({
        id: `site-${site.id}`,
        type: "site",
        name: site.siteName,
        location: site.location,
        siteId: site.id,
      });
    });

    return items;
  }, [sections, sites, currentSite]);

  const performSearch = (query) => {
    setSearchQuery(query);
    setIsSearching(true);

    if (!query.trim()) {
      setSearchResults([]);
      setIsSearching(false);
      return;
    }

    const lowerQuery = query.toLowerCase();
    const results = searchableItems.filter(
      (item) =>
        item.name.toLowerCase().includes(lowerQuery) ||
        (item.location && item.location.toLowerCase().includes(lowerQuery)),
    );

    setSearchResults(results);
    setIsSearching(false);
  };

  return {
    searchQuery,
    searchResults,
    isSearching,
    performSearch,
    clearSearch: () => {
      setSearchQuery("");
      setSearchResults([]);
    },
  };
}
